module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0099.jpg?v=7257d8d9";